/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewDomainsEmailRecord
 */
export interface CRSFSecReviewDomainsEmailRecord {
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewDomainsEmailRecord
     */
    domains: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDomainsEmailRecord
     */
    total: number;
}

/**
 * Check if a given object implements the CRSFSecReviewDomainsEmailRecord interface.
 */
export function instanceOfCRSFSecReviewDomainsEmailRecord(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "domains" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function CRSFSecReviewDomainsEmailRecordFromJSON(json: any): CRSFSecReviewDomainsEmailRecord {
    return CRSFSecReviewDomainsEmailRecordFromJSONTyped(json, false);
}

export function CRSFSecReviewDomainsEmailRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewDomainsEmailRecord {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'domains': json['domains'],
        'total': json['total'],
    };
}

export function CRSFSecReviewDomainsEmailRecordToJSON(value?: CRSFSecReviewDomainsEmailRecord | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'domains': value.domains,
        'total': value.total,
    };
}

